export enum VoucherStatus {
    None = 0,
    Pending = 1,
    Printed = 2,
    Error = 3,
}